import { useQuery } from '@apollo/client';
import { GetViewerTranscriptDocument } from '@sandtech-hub-monorepo/ehub-client';
import { Loading } from '@sandtech-hub-monorepo/ui-kit-site';
import TranscriptContent from './components/TranscriptContent';

export const TranscriptPage = () => {
  const { data } = useQuery(GetViewerTranscriptDocument, {
    fetchPolicy: 'cache-first',
  });

  if (!data) {
    return <Loading />;
  }

  const universityEnrollments = data.viewer.programEnrollments.filter(
    (e) => e.program.isUniversityProgram
  );

  if (universityEnrollments.length === 0) {
    return (
      <div className="flex items-center justify-center min-h-96 text-muted-foreground">
        No program enrollment found.
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center py-8 px-4 md:py-16 md:px-24 print:p-0">
      <TranscriptContent
        viewer={data.viewer}
        programEnrollments={universityEnrollments}
      />
    </div>
  );
};
